export default __webpack_public_path__ + "static/media/coins.17ae54c3.svg";